import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Expense Reports by Vendor</h3>
                <p className="text-sm text-gray-600">
                    Track spending patterns across different service providers and suppliers.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Vendor Analysis</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Comparison:</strong> See which vendors receive the most business from your fleet.</li>
                    <li><strong>Trend Tracking:</strong> Use date filters to see if costs from specific vendors are increasing over time.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Search and Filter</h4>
                <p className="text-sm text-gray-600">
                    Combine <strong>Date Range</strong>, <strong>Vendor Selection</strong>, and <strong>User Filters</strong> to audit transactions and verify billing accuracy.
                </p>
            </section>
        </div>
    );
};

export default Help;
